import React, { useState, useEffect } from "react";

interface AnnouncementProps {
  storageKey: string;
  title: string;
  icon?: string;
  children: React.ReactNode;
}

const Announcement: React.FC<AnnouncementProps> = ({ storageKey, title, icon = "📢", children }) => {
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    const closed = sessionStorage.getItem(storageKey);
    if (closed === "true") {
      setIsVisible(false);
    }
  }, [storageKey]);

  const handleClose = () => {
    setIsVisible(false);
    sessionStorage.setItem(storageKey, "true");
  };

  if (!isVisible) return null;

  return (
    <div
      style={{
        marginBottom: "16px",
        padding: "14px 16px",
        backgroundColor: "rgba(255, 152, 0, 0.15)",
        backdropFilter: "blur(10px)",
        WebkitBackdropFilter: "blur(10px)",
        color: "#FFB74D",
        borderRadius: "8px",
        fontSize: "13px",
        lineHeight: "1.6",
        border: "1px solid rgba(255, 152, 0, 0.3)",
        position: "relative",
      }}
    >
      <button
        onClick={handleClose}
        style={{
          position: "absolute",
          top: "10px",
          right: "10px",
          background: "none",
          border: "none",
          color: "#FFB74D",
          fontSize: "20px",
          cursor: "pointer",
          padding: "0",
          width: "24px",
          height: "24px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          opacity: 0.7,
          transition: "opacity 0.2s",
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.opacity = "1";
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.opacity = "0.7";
        }}
      >
        ×
      </button>
      <div style={{ fontWeight: "500", marginBottom: "4px", display: "flex", alignItems: "center", gap: "6px" }}>
        <span>{icon}</span>
        <span>{title}</span>
      </div>
      <div>{children}</div>
    </div>
  );
};

export default Announcement;
